import { FC } from 'react';
import { Text } from 'internalLibrary';
import classes from 'classnames';
import styles from './AdditionalInformationItem.module.scss';

interface AdditionalInformationItemProps {
  title: string;
  text: string;
}

const AdditionalInformationItem: FC<AdditionalInformationItemProps> = (
  props,
) => {
  const { title, text } = props;
  return (
    <div className={classes(styles.container)}>
      <div className={styles.icon}>-</div>
      <div className={styles['content-wrapper']}>
        <Text weight="bold" dangerouslySetInnerHTML={{ __html: title }} />
        <br />
        <Text dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  );
};

export default AdditionalInformationItem;
